import styled from "styled-components";

export const AppContainer = styled.div`
    direction: ltr;
    text-align: ${(props) => (props.direction === "rtl")?"right":"left"};
    height: 100%;
    position: relative;
`;